<template>
    <div class="np-search-panel__wrapper" :class="[classes, active]">  
        <div class="np-search-panel px-4" :class="active">
            <div class="np-search-panel__header">
                <div class="np-search-group np-with-icon-right w-100">
                    <svg class="field-icon"><use href="@/assets/images/icons/search.svg#icon"></use></svg>                    
                    <input type="text" ref="searchInput" class="np-search-input" :placeholder="$t('search.search')" v-model="searchValue" @focus="handleFocus"/>
                    <div class="field-hotkey">
                        <span class="me-1">CTRL</span>
                        <span>F</span>
                    </div>
                </div>           
            </div>
            <div class="np-search-panel__body">
                <div class="np-search-variants">
                    <div class="np-search-variants__default">
                        <div class="np-group">
                            <button class="np-btn np-btn-m np-btn-secondary me-2">{{ $t('search.groupTeam') }}</button>
                            <button class="np-btn np-btn-m np-btn-secondary me-2">{{ $t('search.groupUsers') }}</button>
                            <button class="np-btn np-btn-m np-btn-secondary me-2">{{ $t('search.groupProjects') }}</button>
                            <button class="np-btn np-btn-m np-btn-secondary ">{{ $t('search.groupTasks') }}</button>
                        </div>
                    </div>
                    <div class="np-search-variants__history">
                        <div class="np-group justify-between pt-2 pb-2">
                            <div class="d-flex flex-grow-1 np-font-ml np-f-medium">{{ $t('search.lastSearch') }}</div>
                            <button type="button" class="np-btn np-danger np-outline d-flex np-borderless">
                                <svg class="icon"><use href="@/assets/images/icons/trash.svg#icon"></use></svg> 
                                {{ $t('search.lastSearchClear') }}
                            </button>
                        </div>
                        <ul class="np-list np-search-variants__history-list">
                            <li><div class="np-group align-items-center pt-2 pb-3"><svg class="icon"><use href="@/assets/images/icons/clock.svg"></use></svg> Последние запросы</div></li>
                            <li><div class="np-group align-items-center pt-2 pb-3"><svg class="icon"><use href="@/assets/images/icons/clock.svg"></use></svg> Последние запросы</div></li>
                            <li><div class="np-group align-items-center pt-2 pb-3"><svg class="icon"><use href="@/assets/images/icons/clock.svg"></use></svg> Последние запросы</div></li>
                            <li><div class="np-group align-items-center pt-2 pb-3"><svg class="icon"><use href="@/assets/images/icons/clock.svg"></use></svg> Последние запросы</div></li>
                        </ul>
                    </div>                     
                    <div class="np-search-variants__result">

                    </div>                    
                </div>
            </div>
        </div>
    </div>
    <div class="np-search-panel__backdrop"  :class="active" @click="handleBackdropClick"></div>
</template>

<script>
import Config from '../../config.js'

export default {
    props: {
        classes: {
            default: ""
        }
    }, 
    mounted: function () {
        this.selectedTab = this.activeTab
        window.addEventListener('keydown', this.handleKeyDown)
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown)
    },    
    data() {
        return {
            Config,
            active: "",
            searchValue: ""
        }
    },      
    methods: {    
        handleFocus() {
            this.active = "active";
        },
        handleKeyDown(e) {
            if ((e.ctrlKey || e.metaKey) && e.code === 'KeyF') {
                e.preventDefault()
                this.handleFocus()
                this.$nextTick(() => {
                    this.$refs.searchInput?.focus()
                })
            }
            if (e.key === 'Escape') {
                this.handleBackdropClick()
                this.$refs.searchInput?.blur()
            }
        },
        handleBackdropClick() {
            this.searchValue = ""            
            this.active = ""
        }
    }
}
</script>

<style scoped>
    .np-search-panel__backdrop.active {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: var(--color-primary-800);
        opacity: 0.7;
        z-index: 10000;
    }
    .np-search-panel__wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 2;
    }
    .np-search-panel__wrapper.active {
        z-index: 10001;
    }
    .np-search-panel {
        width: 100%;
    }
    .np-search-panel.active .np-search-panel__header {
        margin-top: 10px;
    }
    .np-search-panel__body {
        display: none;
        padding-top: var(--base-value-2);
    }
    .np-search-panel.active .np-search-panel__body {
        display: block;
    }
    .np-search-panel.active {
        position: absolute;
        top: -11px;
        background-color: var(--color-secondary-10);
        border-bottom-left-radius: var(--base-value-2);
        border-bottom-right-radius: var(--base-value-2);
    }
    .np-search-input {
        display: flex;
        border-radius: var(--base-value-2);
        padding: var(--custom-value-1) var(--base-value-5) var(--custom-value-1) var(--base-value-3);
        outline: none;
        width: 100%;
        height: 38px;
        border: 1px solid var(--color-primary-600);
        background-color: var(--color-primary-650);
        color: var(--color-primary-300);
    }
    .np-search-panel.active .np-search-panel__header .np-search-input {
        background-color: var(--color-primary-50);
    }
    .np-search-group {
        display: flex;
        position: relative;
    }
    .np-search-group .field-icon { 
        color: var(--color-primary-200);
        position: absolute; 
    }
    .np-search-panel.active .np-search-group .field-icon {
        color: var(--color-primary-600);
    }
    .np-search-group .field-icon { 
        left: 10px; top: calc(50% - 12px); 
    }   
    .np-search-group .field-hotkey { 
        position: absolute; 
    }
    .np-search-group .field-hotkey { 
        display: flex;
        right: 10px; top: calc(50% - 12px); 
    }      
    .np-search-group .field-hotkey span {
        border-radius: 5px;
        font-size: 10px;
        padding: 5px 10px;
        color: var(--color-primary-200);
        background-color: var(--color-primary-600);
    }
    .np-search-group input {
        padding-left: 40px;
        padding-right: 90px;
    }
    .np-search-variants {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-top: var(--base-value-2);
        padding-bottom: var(--base-value-4);
    }
    .np-search-variants__history {
        display: flex;
        flex-direction: column;
        padding-top: var(--base-value-4);
    }
    .np-search-variants__history-list li {
        border: none;
        color: var(--color-primary-500);
    }
</style>